import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { media } from 'components/styles';

// Import components
import {
	Wrapper,
	Bg,
	GradientBox,
	Box,
	GradientRadial,
	Content,
	ButtonClose,
	IconCloseStyled
} from './styles';

function PaymentConfirmTemplate({
	children,
	onClose = false,
	toggle = () => {},
	modalHeight = 39
}) {
	const handleOnClose = () => onClose && toggle();
	return (
		<Wrapper className="wrapper">
			<Bg onClick={handleOnClose} />
			<GradientBoxStyled className="gradient" modalHeight={modalHeight}>
				<BoxStyled className="content-box">
					{onClose && (
						<ButtonClose onClick={toggle}>
							<IconCloseStyled height="1.9rem" width="1.9rem" />
						</ButtonClose>
					)}
					<GradientRadialStyled />
					<ContentStyled className="CONTENT">{children}</ContentStyled>
				</BoxStyled>
			</GradientBoxStyled>
		</Wrapper>
	);
}

const GradientBoxStyled = styled(GradientBox)`
	width: 100%;
	height: auto;
	${media.min.min(css`
		height: ${({ modalHeight }) => modalHeight}rem;
	`)};
	background: transparent;
	padding: 0;
	border: 1px solid #707070;
`;

const BoxStyled = styled(Box)`
	height: 100%;
	padding: 10vh 1.5rem;
	${media.min.xmin(css`
		padding: 6.8rem 6.5rem 7.5rem 6.5rem;
	`)}
`;

const GradientRadialStyled = styled(GradientRadial)`
	background: radial-gradient(
		ellipse at center,
		${({ theme }) => theme.payment.gradientRadial.color1} 12%,
		${({ theme }) => theme.payment.gradientRadial.color2} 93%
	);
`;

const ContentStyled = styled(Content)`
	padding-top: 0;
	text-align: center;
`;

PaymentConfirmTemplate.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	onClose: PropTypes.bool,
	toggle: PropTypes.func,
	modalHeight: PropTypes.number
};

export default PaymentConfirmTemplate;
